import { useEffect, useState } from "react";

export function useRestoreScrollOnFetching(isFetching: boolean) {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!isFetching || !element) return;

    // Allow scroll if passed 0.3 of scrollable area
    const scrollableHeight = element.scrollHeight - element.clientHeight;
    if (element.scrollTop / scrollableHeight >= 0.3) {
      element.scroll({ top: 0, behavior: "smooth" });
    }
  }, [isFetching, element]);

  return setElement;
}
